<template>
  <v-dialog
    v-model="dialog"
    width="1200"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        color="primary"
        width="50"
        height="50"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon size="45">
          mdi-plus-circle
        </v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        {{ title }}
      </v-card-title>

      <v-card-text>
        <v-form
          ref="form"
          v-model="formValid"
          @submit.prevent="save()"
        >
          <slot />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="#6A6E7B"
          outlined
          @click="closeModal()"
        >
          CANCELAR
        </v-btn>
        <v-btn
          class="white--text"
          type="submit"
          color="#2ABD49"
          :loading="loading"
          @click="save()"
        >
          SALVAR
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import NotificationMixin from '@/app/arch/mixins/NotificationMixin';

export default {
  nane: 'ProductBaseModal',
  mixins: [NotificationMixin],
  props: {
    loading: {
      type: Boolean,
    },
    title: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    dialog: false,
    formValid: false,
  }),
  methods: {
    validateForm() {
      return this.$refs.form.validate();
    },
    save() {
      if (!this.validateForm()) {
        this.showErrorToast({
          title: 'Ocorreu um erro!',
          text: 'Preencha os dados corretamente.',
        });
        return;
      }
      this.$emit('save');
    },
    closeModal() {
      this.dialog = false;
    },
  },
};
</script>

<style>

</style>
